import { default as doSearchModel } from './searchModel';

export {};

export const sagaSearchModel = doSearchModel.sagas;
